<div id="insert-user-panel"></div>

<ng-template #mainContent>
    <ng-content></ng-content>
</ng-template>